"use strict";

var constants = require('../constants');

var constructors = require('../products_list');

module.exports = function getMatchingConstructor(type) {
  switch (type) {
    case constants.CUSTOM_SAMPLES:
      return constructors.CustomSamples;

    case constants.ENVELOPE_REPRINTS:
      return constructors.EnvelopeReprints;

    case constants.ENVELOPES:
      return constructors.Envelopes;

    case constants.CLASSIC_WEDDING_INVITATIONS:
      return constructors.ClassicInvitationSuite;

    case constants.CLASSIC_WEDDING_INVITATION_REPRINTS:
      return constructors.ClassicInvitationSuiteReprints;

    case constants.RIBBON_WEDDING_INVITATIONS:
      return constructors.RibbonInvitationSuite;

    case constants.RIBBON_WEDDING_INVITATION_REPRINTS:
      return constructors.RibbonInvitationSuiteReprints;

    case constants.FLORAL_WEDDING_INVITATIONS:
      return constructors.FloralInvitationSuite;

    case constants.FLORAL_WEDDING_INVITATION_REPRINTS:
      return constructors.FloralInvitationSuiteReprints;

    case constants.VELLUM_WEDDING_INVITATIONS:
      return constructors.VellumInvitationSuite;

    case constants.VELLUM_WEDDING_INVITATION_REPRINTS:
      return constructors.VellumInvitationSuiteReprints;

    case constants.FLAT_WEDDING_INVITATION_REPRINTS_COVID:
      return constructors.FlatInvitationSuiteReprintsCovid;

    case constants.LETTERPRESS_WEDDING_INVITATIONS:
      return constructors.LetterpressInvitationSuite;

    case constants.LETTERPRESS_WEDDING_INVITATION_REPRINTS:
      return constructors.LetterpressInvitationSuiteReprints;

    case constants.LETTERPRESS_WEDDING_INVITATION_REPRINTS_COVID:
      return constructors.LetterpressInvitationSuiteReprintsCovid;

    case constants.LETTERPRESS_SAVE_THE_DATES:
      return constructors.LetterpressSaveTheDates;

    case constants.LETTERPRESS_SAVE_THE_DATE_REPRINTS:
      return constructors.LetterpressSaveTheDateReprints;

    case constants.SAVE_THE_DATES:
      return constructors.SaveTheDates;

    case constants.SAVE_THE_DATE_REPRINTS:
      return constructors.SaveTheDateReprints;

    case constants.PHOTO_SAVE_THE_DATES:
      return constructors.PhotoSaveTheDates;

    case constants.PHOTO_SAVE_THE_DATE_REPRINTS:
      return constructors.PhotoSaveTheDateReprints;

    case constants.THANK_YOU_CARDS:
      return constructors.ThankYouCards;

    case constants.THANK_YOU_CARD_REPRINTS:
      return constructors.ThankYouCardReprints;

    case constants.SQUARE_WEDDING_PROGRAMS:
      return constructors.SquareWeddingPrograms;

    case constants.SQUARE_WEDDING_PROGRAM_REPRINTS:
      return constructors.SquareWeddingProgramReprints;

    case constants.BASIC_BOOKLET_WEDDING_PROGRAMS:
      return constructors.BasicBookletWeddingPrograms;

    case constants.BASIC_BOOKLET_WEDDING_PROGRAM_REPRINTS:
      return constructors.BasicBookletWeddingProgramReprints;

    case constants.DELUXE_BOOKLET_WEDDING_PROGRAMS:
      return constructors.DeluxeBookletWeddingPrograms;

    case constants.DELUXE_BOOKLET_WEDDING_PROGRAM_REPRINTS:
      return constructors.DeluxeBookletWeddingProgramReprints;

    case constants.FLAT_WEDDING_PROGRAMS:
    case constants.FLAT_BOOKLET_WEDDING_PROGRAMS:
      return constructors.FlatBookletWeddingPrograms;

    case constants.FLAT_WEDDING_PROGRAM_REPRINTS:
    case constants.FLAT_BOOKLET_WEDDING_PROGRAM_REPRINTS:
      return constructors.FlatBookletWeddingProgramReprints;

    case constants.CUSTOM_PRODUCT:
      return constructors.CustomProduct;

    case constants.CUSTOM_SIGNS:
      return constructors.CustomSigns;

    case constants.CUSTOM_SIGN_REPRINTS:
      return constructors.CustomSignReprints;

    case constants.FAVOR_TAGS:
      return constructors.FavorTags;

    case constants.FAVOR_TAG_REPRINTS:
      return constructors.FavorTagReprints;

    case constants.PLACE_CARDS:
      return constructors.PlaceCards;

    case constants.PLACE_CARD_REPRINTS:
      return constructors.PlaceCardReprints;

    case constants.RESERVED_SIGNS:
      return constructors.ReservedSigns;

    case constants.RESERVED_SIGN_REPRINTS:
      return constructors.ReservedSignReprints;

    case constants.SEATING_CHARTS:
      return constructors.SeatingCharts;

    case constants.SEATING_CHART_REPRINTS:
      return constructors.SeatingChartReprints;

    case constants.TABLE_NUMBERS:
      return constructors.TableNumbers;

    case constants.TABLE_NUMBER_REPRINTS:
      return constructors.TableNumberReprints;

    case constants.WEDDING_MENUS:
      return constructors.WeddingMenus;

    case constants.WEDDING_MENU_REPRINTS:
      return constructors.WeddingMenuReprints;

    case constants.LETTERPRESS_WEDDING_MENUS:
      return constructors.LetterpressWeddingMenus;

    case constants.LETTERPRESS_WEDDING_MENU_REPRINTS:
      return constructors.LetterpressWeddingMenuReprints;

    case constants.WEDDING_SIGNS:
      return constructors.WeddingSigns;

    case constants.WEDDING_SIGN_REPRINTS:
      return constructors.WeddingSignReprints;

    case constants.WELCOME_SIGNS:
      return constructors.WelcomeSigns;

    case constants.WELCOME_SIGN_REPRINTS:
      return constructors.WelcomeSignReprints;

    case constants.SILK_RIBBON:
      return constructors.SilkRibbon;

    case constants.VELLUM_JACKETS:
      return constructors.VellumJackets;

    case constants.WAX_SEALS:
      return constructors.WaxSeals;

    case constants.SILK_RIBBON_SAMPLES:
      return constructors.SilkRibbonSamples;

    case constants.CLASSIC_WEDDING_INVITATION_SAMPLES:
      return constructors.ClassicInvitationSamples;

    case constants.LETTERPRESS_WEDDING_INVITATION_SAMPLES:
      return constructors.LetterpressInvitationSamples;

    case constants.ACCESSORIES_THANK_YOU_CARDS:
      return constructors.AccessoriesThankYouCards;

    case constants.COMPONENTS_CARDS:
      return constructors.ComponentsCards;

    case constants.DOUBLE_THICK_EXAMPLE_CARDS:
      return constructors.DoubleThickExampleCards;

    case constants.ENVELOPE_LINER_INSERTS:
      return constructors.EnvelopeLinerInserts;

    case constants.INFORMATION_2018_CARDS:
      return constructors.Information2018Cards;

    case constants.INVITATION_THANK_YOU_CARDS:
      return constructors.InvitationThankYouCards;

    case constants.LETTERPRESS_SAMPLE_CARDS:
      return constructors.LetterpressSampleCards;

    case constants.ORDER_TIMELINE_CARDS:
      return constructors.OrderTimelineCards;

    case constants.PACKED_BY_CARDS:
      return constructors.PackedByCards;

    case constants.PHOTOGRAPHY_INSERTS:
      return constructors.PhotographyInserts;

    case constants.RIBBON_INSTRUCTIONS:
      return constructors.RibbonInstructions;

    case constants.RIBBON_SAMPLE_INSTRUCTIONS:
      return constructors.RibbonSampleInstructions;

    case constants.SAVE_THE_DATE_THANK_YOU_CARDS:
      return constructors.SaveTheDateThankYouCards;

    case constants.STANDARD_INSTRUCTIONS:
      return constructors.StandardInstructions;

    case constants.WHY_SHINE_CARDS:
      return constructors.WhyShineCards;

    case constants.CUSTOM_COLOR_CHARTS:
      return constructors.CustomColorCharts;

    case constants.COLOR_CHARTS:
      return constructors.ColorCharts;

    case constants.COLOR_CHART_LINERS:
      return constructors.ColorChartLiners;

    case constants.COLOR_CHART_KITS:
      return constructors.ColorChartKits;

    case constants.SAMPLE_CLASSIC_INVITATION_SUITES:
      return constructors.SampleClassicInvitationSuites;

    case constants.RIBBON_SAMPLE_CARDS:
      return constructors.RibbonSampleCards;

    case constants.LINER_SAMPLES:
      return constructors.LinerSamples;

    case constants.WEDDING_PLANNER_BOXES:
      return constructors.WeddingPlannerBoxes;

    case constants.WEDDING_POSTPONEMENT_ANNOUNCEMENTS:
      return constructors.WeddingPostponementAnnouncements;

    default:
      throw new Error("Type '".concat(type, "' did not match a Constructor"));
  }
};